/* eslint-disable react-hooks/exhaustive-deps */
import { Input } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { useSmartFormContext } from '../../../../../context/smart-form.context'
import { smartFormConst } from '../../../../../utils/action.constant'
import { toSnakeCase } from '../../../../../utils/common.util'
import { loadFinalValue } from '../../../../../utils/form.util'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { startsWith } from 'lodash'

const PhoneNumberWithCountryCode = ({
  field,
  isDisabled = true,
  isRequired,
  onValidate,
  onError,
  scrollToBottom = () => {},
}) => {
  const {
    state: { fields: formFields },
    dispatch,
  } = useSmartFormContext()
  const fields = !!formFields[field.form_id] ? formFields[field.form_id] : {}

  const onChange = value => {
    let regEx = /^(\+\d{1,3}[- \|]?)?\d{10}$/
    if (!!isRequired) {
      if (!!value) {
        if (!!regEx.test(value)) {
          onError(null)
          onValidate(true)
        } else {
          onValidate(false)
          onError('Invalid phone number')
        }
      } else {
        onValidate(false)
      }
    } else {
      if (!!regEx.test(value)) {
        onError(null)
        onValidate(true)
      } else {
        onValidate(false)
        onError('Invalid phone number')
      }
    }
    dispatch({
      type: smartFormConst.SET_FIELD_VALUE,
      fieldId: field.field_id,
      formId: field.form_id,
      value: loadFinalValue(field, value),
    })
  }

  let value1 = fields[field.field_id] ? fields[field.field_id].field_value : ''

  let value = value1.includes('|')
    ? value1.includes('+')
      ? value1
      : '+' + value1
    : value1.length > 4
    ? '+91|' + value1
    : value1

  useEffect(() => {
    if (!!value && value) {
      let regEx = /^(\+\d{1,3}[- \|]?)?\d{10}$/
      if (!!value && value) {
        if (!!regEx.test(value)) {
          onError(null)
          onValidate(true)
        } else {
          onValidate(false)
          onError('Invalid phone number')
        }
      } else {
        onValidate(false)
      }
      dispatch({
        type: smartFormConst.SET_FIELD_VALUE,
        fieldId: field.field_id,
        formId: field.form_id,
        value: loadFinalValue(field, value),
      })
    }
  }, [value])

  // return (
  //   <Input
  //     className={`short-text-field-${toSnakeCase(field.field_name)}`}
  //     autoComplete="off"
  //     type="tel"
  //     required={isRequired}
  //     key={field.field_name}
  //     isDisabled={isDisabled}
  //     placeholder={field.field_place_holder + `Enter ${field.field_name}`}
  //     borderRadius="md"
  //     size="sm"
  //     name="phone_number"
  //     value={value}
  //     onChange={e => onChange(e.target.value)}
  //   />
  // )

  return (
    <PhoneInput
      onChange={(v, c, e, fv) => {
        let formatValue = fv.replace(/ /g, '|').replace(/-/g, '')
        onChange(formatValue)
      }}
      value={value}
      disabled={isDisabled}
      country={'in'}
      onlyCountries={["au", "in", "us", "bd", "gb", "de", "fr", "lb", "hk", "sk"]}
      countryCodeEditable={false}
      name="phone_number"
      enableSearch
      buttonStyle={{ border: 'none' }}
      buttonClass="rounded "
      inputStyle={{
        maxWidth: '260px',
        margin: 'auto',
        border: 'none',
        boxShadow: '0 2px 6px rgb(0,0,0,0.05)',
      }}
      isValid={(inputNumber, country, countries) => {
        scrollToBottom('select-scroll')
        return countries.some(country => {
          return (
            startsWith(inputNumber, country.dialCode) ||
            startsWith(country.dialCode, inputNumber)
          )
        })
      }}
    />
  )
}

export default PhoneNumberWithCountryCode
